module.exports = __webpack_public_path__ + "img/clientSlide06Img_02.9ab10a9a.png";